import { BonusResult } from "slotworks/model/gameplay/records/results/bonus-result";

export class EJBonusWheelResult extends BonusResult {
    public resultType: string = "EJBonusWheelResult";
    public prizeSequence: string[];

    public slotSpinsWon: number = 0;
}
